export const pt = {
  nav: { guides: "Guias", pricing: "Preços", login: "Entrar", start: "Começar grátis", credits: "créditos", credit: "crédito", quick: "Acesso rápido", dashboard: "Meu painel", buy: "Comprar créditos", logout: "Sair" },
  footer: {
    tagline: "Deixe qualquer arquivo pronto para imprimir, em casa ou na gráfica. Ferramentas com IA para quem imprime, e para gráficas também.",
    tools: "Ferramentas", allTools: "Todas as ferramentas", guides: "Guias", account: "Conta", pricing: "Preços", dashboard: "Meu painel", login: "Entrar", rights: "Arquivos prontos para imprimir",
  },
  tools: {
    ampliar: {
      name: "Ampliar em HD",
      short: "Corrige imagens borradas, pequenas ou pixelizadas",
      description: "Imagem pequena, borrada ou pixelizada? A IA reconstrói os detalhes para imprimir nítido, até em tamanhos grandes como pôsteres e banners.",
      badges: ["Até 4x maior", "300/600 DPI", "RGB + CMYK"],
    },
    vetorizar: {
      name: "Vetorizar logo",
      short: "Logo nítida em qualquer tamanho",
      description: "Transforme sua logo em vetor para imprimir nítido em qualquer tamanho: adesivos, placas, banners e recorte. Abre no CorelDRAW e no Illustrator.",
      badges: ["SVG · PDF · EPS · AI", "Corel e Illustrator"],
    },
    "remover-fundo": {
      name: "Remover fundo",
      short: "Fundo transparente em um clique",
      description: "Remova o fundo em um clique para adesivos, canecas, camisetas, etiquetas e fotos de produto. Baixe um PNG transparente em alta qualidade.",
      badges: ["PNG transparente", "Bordas precisas"],
    },
    "pdf-imagem": {
      name: "PDF para imagem",
      short: "Transforma páginas de PDF em JPG, PNG, BMP ou TIFF",
      description: "Transforme cada página do PDF em imagem de alta qualidade (JPG, PNG, BMP ou TIFF) para imprimir, postar ou mandar para a gráfica. Uma página ou todas em ZIP.",
      badges: ["Até 600 DPI", "JPG · PNG · BMP · TIFF"],
    },
  },
  formatHint: { svg: "Universal · Corel e Illustrator", pdf: "Vetorial · abre em qualquer programa", eps: "Clássico de gráfica · Corel", ai: "Illustrator (compatível PDF)", png: "Prévia em imagem" },
  landing: {
    badge: "Arquivos prontos para imprimir em minutos",
    h1a: "Nós melhoramos",
    h1b: "suas imagens,",
    h1c: "em um clique.",
    sub: "Foto borrada, logo pixelizada ou um PDF que precisa virar imagem? Resolva em segundos e imprima em casa ou mande para qualquer gráfica sem o arquivo voltar.",
    cta: "Quero minhas 5 imagens grátis",
    after: "Depois, US$5 por 10 usos",
    checks: ["Sem precisar saber design", "Impressora de casa e gráfica", "Sem cartão para começar"],
    output: "Pronto para imprimir",
    imgAlt: "Materiais impressos",
    audienceEyebrow: "Para quem é",
    audienceTitle: "Feito para quem precisa imprimir",
    personal: {
      tag: "Vai imprimir algo?",
      title: "Seu arquivo, nítido no papel",
      text: "Convites, panfletos, adesivos, banners, fotos, camisetas. Envie o que você tem e receba um arquivo que a sua impressora ou a gráfica aceita: nítido, no tamanho certo e no formato certo.",
      bullets: ["Corrija imagens pequenas ou borradas antes de imprimir", "Logo em vetor para adesivos, placas e recorte", "Tire o fundo para canecas, camisetas e etiquetas", "Transforme PDF em imagem para imprimir ou enviar"],
      cta: "Arrumar meu arquivo",
    },
    shop: {
      tag: "Tem uma gráfica?",
      title: "Pare de devolver arquivos",
      text: "Salve as artes em baixa resolução dos seus clientes, vetorize logos para Corel e Illustrator e entregue arquivos CMYK prontos para a máquina, em minutos.",
      bullets: ["CMYK e DPI gravados no arquivo", "SVG, PDF, EPS e AI para Corel e Illustrator", "Pague por uso, sem mensalidade"],
      cta: "Ver preços",
    },
    toolsEyebrow: "04 ferramentas",
    toolsTitle: "Quatro ferramentas para arrumar qualquer arquivo antes de imprimir",
    useTool: "Usar ferramenta",
    stepsEyebrow: "Como funciona",
    steps: [
      { title: "Envie seu arquivo", text: "Imagem, logo ou PDF, direto do celular ou do computador." },
      { title: "A IA arruma", text: "Mais nítido, maior, vetorizado ou sem fundo, em segundos." },
      { title: "Baixe e imprima", text: "Escolha o formato. RGB para impressora de casa, CMYK para gráfica." },
    ],
    features: [
      { title: "Simples para qualquer pessoa", text: "Sem Photoshop, sem saber design. Envie, clique e baixe." },
      { title: "Resultado profissional", text: "O mesmo tipo de IA usado por estúdios, com saída em alta resolução pronta para impressão." },
      { title: "Pague só se usar", text: "5 usos grátis. Depois, US$5 por 10 usos em qualquer ferramenta. Créditos não expiram." },
    ],
    ctaTitle: "Seus primeiros 5 arquivos são grátis.",
    ctaSub: "Entre com o Google em segundos. Sem cartão.",
    ctaBtn: "Criar conta grátis",
  },
  auth: {
    google: "Continuar com Google",
    googleError: "Não foi possível entrar com Google. Tente novamente.",
    registerTitle: "Crie sua conta", loginTitle: "Entrar",
    registerSub: "Entre com o Google e ganhe 5 imagens grátis em qualquer ferramenta.", loginSub: "Entre com o Google para usar suas 5 imagens grátis e seu histórico.",
    orEmail: "acesso admin", adminLogin: "Login de admin com e-mail", googleOnlyNote: "Só contas Google podem usar créditos.", name: "Nome", email: "E-mail", password: "Senha",
    registerBtn: "Criar conta", loginBtn: "Entrar",
    hasAccount: "Já tem conta?", noAccount: "Ainda não tem conta?", signup: "Cadastre-se",
    welcomeNew: "Conta criada! Você ganhou 5 créditos.", welcomeBack: "Bem-vindo de volta!",
  },
  dash: {
    eyebrow: "Painel", hello: "Olá, {name}", balance: "Saldo disponível",
    perFile: "créditos · prévia grátis, 1 crédito por download", buy: "Comprar 10 por US$5",
    history: "Histórico de arquivos", files: "{n} arquivos", removed: "Arquivo removido do histórico",
    confirmTitle: "Remover este arquivo?", confirmText: "\"{name}\" será removido do seu histórico. Isso não pode ser desfeito.", cancel: "Cancelar", remove: "Remover",
  },
  history: {
    empty: "Nenhum arquivo ainda. Escolha uma ferramenta e envie seu primeiro arquivo.",
    processing: "Processando", failed: "Falhou", done: "Pronto", unlocked: "Liberado · downloads grátis",
  },
  tool: {
    newFile: "Novo arquivo", processingTitle: "Processando {file}",
    processingSlow: "A IA está reconstruindo os detalhes. Pode levar de 20 segundos a 2 minutos.",
    processingFast: "Isso costuma levar poucos segundos.",
    uploading: "Enviando...", uploadPdf: "Envie seu PDF", uploadImg: "Envie sua imagem",
    hintPdf: "PDF até 40 MB e 60 páginas", hintImg: "PNG, JPG, WEBP, BMP ou TIFF até 40 MB e 100 megapixels",
    tooBig: "{name} tem {mb} MB. O limite é 40 MB: comprima ou reduza a imagem e tente de novo.",
    tooManyPixels: "{name} tem {mp} megapixels ({w}×{h}). O limite é 100 MP: reduza a imagem e tente de novo.",
    clickOrDrag: "Clique ou arraste o arquivo",
    tryAnother: "Tentar outro arquivo", ready: "Arquivo pronto!",
    noCredits: "Sem créditos. Compre um pacote para continuar.",
    export: "Exportar", pages: "{n} páginas", page1: "1 página", settings: "Configuração",
    chooseLater: {
      upscale: "Você escolhe formato, cor (RGB/CMYK) e DPI depois do processamento.",
      pdf: "Você escolhe formato, cor (RGB/CMYK) e DPI depois do processamento.",
      remove_bg: "Você escolhe o formato (PNG, TIFF, WEBP ou JPG) e o DPI depois do processamento.",
      vectorize: "Você escolhe o formato vetorial (SVG, PDF, EPS ou AI) depois do processamento.",
    },
    costs: "Prévia grátis · 1 crédito por download", balance: "Saldo: {n}", buy: "Comprar créditos",
    quality: "Qualidade", ultra: "Ultra IA", ultraHint: "Restauração natural, ideal para fotos e rostos",
    fast: "Fiel", fastHint: "Mais rápido, preserva o original",
    scale: "Ampliação", x2Hint: "Dobra a resolução", x4Hint: "Ultra para impressão",
  },
  vec: {
    recraft: "Recraft IA", recraftHint: "Formas limpas e suaves, ótimo para logos coloridas",
    precise: "Traço preciso", preciseHint: "Segue cada borda, ótimo para letras e símbolos pequenos",
    compare: "Geramos com 2 motores. Compare e clique no melhor: você paga só o download escolhido.", single: "Resultado vetorizado",
    choose: "Escolher", selected: "Escolhido", zoom: "Ver ampliado", downloading: "Você vai baixar a versão {e}",
    enhance: "Nitidez para letras pequenas", enhanceOn: "Ligado", enhanceOnHint: "Amplia com IA antes de vetorizar (alguns segundos a mais)",
    enhanceOff: "Desligado", enhanceOffHint: "Mais rápido, usa a imagem como está",
  },
  renew: {
    title: "Não conseguimos renovar seu Plano Gráfica", text: "A cobrança automática falhou. Renove para receber os 100 créditos do mês e voltar a usar o envio em lote.", cta: "Renovar agora", redirecting: "Abrindo o pagamento seguro...",
  },
  batch: {
    title: "Lote", progress: "{d} de {n} prontos", open: "Abrir", back: "Voltar ao lote", uploading: "Enviando {i} de {n}...", queued: "Na fila",
    planOnly: "Envio em lote é exclusivo do Plano Gráfica. Enviamos só o primeiro arquivo.", hint: "Envio em lote: selecione vários arquivos de uma vez", upsell: "Quer enviar vários arquivos de uma vez? Conheça o Plano Gráfica", max: "Máximo de {n} arquivos por lote",
  },
  result: {
    original: "Original", result: "Resultado", noBg: "Sem fundo", dragHint: "Arraste a alça para comparar antes e depois", showNoBg: "Ver sem fundo", showOriginal: "Ver original",
    bitmap: "Bitmap original", vector: "Vetor (curvas)", page: "Página {n}",
  },
  dl: {
    format: "Formato do arquivo", color: "Perfil de cor", rgbHint: "Impressora de casa, telas e web", cmykHint: "Gráficas (offset e digital)",
    cmykOnly: "Disponível em JPG, TIFF e PDF", resolution: "Resolução gravada",
    dpiHints: { 150: "Rascunho", 300: "Padrão gráfica", 600: "Alta precisão" },
    pages: "Páginas", all: "Todas ({n})", zip: "Pacote ZIP", onlyPage: "Só a página {n}", single: "Arquivo único",
    jpgNoAlpha: "JPG não suporta transparência: o fundo sai branco.",
    vectorTip: "No CorelDRAW use Arquivo › Importar (SVG, PDF ou EPS). No Illustrator, abra o .AI ou o PDF direto.",
    download: "Baixar", free: "Cada download usa 1 crédito.", freeUnlimited: "Downloads ilimitados na sua conta.",
    freeUnlocked: "Arquivo já liberado: baixe de novo em qualquer formato sem gastar crédito.", doneFree: "Download iniciado! Nenhum crédito usado.",
    confirmTitle: "Baixar este arquivo?", confirmText: "Este download vai usar 1 crédito. Seu saldo atual: {n}.", confirmBtn: "Usar 1 crédito e baixar", cancel: "Cancelar",
    noCredits: "Você precisa de 1 crédito para baixar o arquivo limpo.", buy: "Comprar créditos", downloading: "Preparando arquivo...", done: "Download iniciado! 1 crédito usado.",
    lockedTitle: "Prévia com marca d'água", lockedText: "Gostou? Baixe para receber o arquivo limpo em alta definição.",
  },
  pricing: {
    eyebrow: "Preços", title: "Simples e justo.",
    sub: "Veja o resultado grátis com marca d'água. Cada download usa 1 crédito, em qualquer ferramenta. Os créditos não expiram.",
    free: "Grátis", toStart: "para começar",
    freeList: ["5 usos grátis ao criar a conta", "Todas as 4 ferramentas", "Prévia grátis antes de pagar", "Histórico de arquivos"],
    pack: "Pacote", credits10: "{n} créditos", perFile: "{n} créditos · {per} por arquivo", extraNote: "Cada pacote extra tem 10% de desconto: {price}", save: "Você economiza {v}",
    packs: "{n} pacotes", pack1: "1 pacote", buyBtn: "Comprar {n} créditos", secure: "Pagamento seguro via Stripe",
    cancelled: "Pagamento cancelado. Nenhuma cobrança foi feita.",
    shop: "Plano Gráfica", shopTag: "Para gráficas", perMonth: "/mês", shopCredits: "100 créditos por mês · {per} por arquivo",
    shopList: ["100 créditos todo mês", "Créditos não usados acumulam", "Envio em lote: vários arquivos de uma vez", "Cancele quando quiser"],
    subscribe: "Assinar Plano Gráfica", active: "Seu plano está ativo", renews: "Renova em {d} com +100 créditos", endsOn: "Cancelado · ativo até {d}",
    cancelPlan: "Cancelar plano", resumePlan: "Manter plano", cancelTitle: "Cancelar o Plano Gráfica?", cancelText: "Você continua com o plano e seus créditos até {d}. Depois disso não haverá novas cobranças.", keep: "Voltar", confirmCancel: "Sim, cancelar",
    cancelDone: "Plano cancelado. Ele fica ativo até o fim do período.", resumeDone: "Seu plano continua ativo.",
  },
  pay: {
    checking: "Confirmando pagamento...", added: "Créditos adicionados!", updated: "Seu saldo já foi atualizado.",
    notDone: "Pagamento não concluído", stillProcessing: "Ainda processando", noCharge: "Nenhuma cobrança foi feita.",
    refresh: "Atualize o painel em alguns instantes.", goDash: "Ir para o painel",
  },
  owner: {
    eyebrow: "Dono", title: "Visão geral do site", menu: "Painel do dono",
    users: "Usuários", usersSub: "+{d7} em 7 dias · +{d30} em 30 dias",
    files: "Arquivos processados", filesSub: "{d7} nos últimos 7 dias · {f} com falha",
    sales: "Faturamento", salesSub: "{n} vendas · {c} créditos vendidos · {b} compradores",
    chartFiles: "Arquivos processados por dia (30 dias)", chartRevenue: "Faturamento por dia (30 dias)",
    byTool: "Por ferramenta", topCustomers: "Clientes que mais compram", allSales: "Todas as vendas", exportCsv: "Exportar CSV", colCustomer: "Cliente", colSpent: "Total gasto", colOrders: "Compras", colCredits: "Créditos", colFiles: "Arquivos", colLast: "Última compra", colDate: "Data", colPacks: "Pacotes", colAmount: "Valor", recentSales: "Últimas vendas", recentUsers: "Últimos cadastros", noSales: "Nenhuma venda ainda",
  },
  faq: { title: "Perguntas frequentes", related: "Ferramentas e guias relacionados" },
  hub: { guidesHint: "Novo em arquivos para impressão? Leia os" },
  guide: { updated: "atualizado em" },
  notFound: { title: "Página não encontrada", sub: "O link pode estar quebrado ou a página pode ter mudado de lugar.", home: "Voltar ao início", tools: "Ver todas as ferramentas" },
  examples: {
    eyebrow: "Exemplos reais", title: "Veja a diferença antes de imprimir",
    sub: "Estes resultados foram feitos pelas nossas próprias ferramentas, sem retoque.",
    ampliar: "Uma foto pequena e borrada em baixa resolução ampliada 4x, com rostos naturais e nítida para imprimir.",
    vetorizar: "Uma logo borrada e de baixa qualidade transformada em curvas vetoriais limpas.",
    "remover-fundo": "Uma foto real com fundo poluído, agora com fundo transparente e limpo.",
    pdfPages: "páginas", pdfCaption: "Entra um PDF, sai cada página em JPG, PNG, BMP ou TIFF",
    "pdf-imagem": "Envie um documento PDF e exporte cada página em JPG, PNG, BMP ou TIFF, de 150 a 600 DPI, em RGB ou CMYK.",
    before: "Antes", after: "Depois", drag: "Arraste para comparar", try: "Testar com o seu arquivo",
  },
  alert: {
    lastTitle: "Resta só 1 imagem",
    emptyTitle: "Você usou todas as suas imagens",
    text: "Pegue mais 10 por US$5 e continue arrumando seus arquivos. Créditos não expiram.",
    cta: "Comprar 10 por US$5",
    googleOnly: "Os créditos só podem ser usados com uma conta Google. Saia e entre com o Google para usar suas imagens.",
    switchCta: "Entrar com Google",
  },
  promo: {
    guest: "5 imagens GRÁTIS em qualquer ferramenta. É só entrar com o Google, sem cartão.",
    guestCta: "Pegar agora",
    userOne: "Você tem 1 crédito · 1 crédito = 1 download · Mais 10 por US$5",
    googleOnly: "Créditos só funcionam com login Google. Toque para trocar de conta.",
    user: "Você tem {n} créditos · 1 crédito = 1 download · Mais 10 por US$5",
    unlimited: "Créditos ilimitados ativos na sua conta",
  },
  free: {
    badgeNum: "5 GRÁTIS",
    badge: "imagens para começar, sem cartão",
    note: "Entre com a sua conta Google para usar suas 5 imagens grátis. Veja a prévia grátis e use 1 crédito só quando baixar.",
    sticker: "imagens grátis",
    authTitle: "5 imagens grátis esperando por você",
    authText: "Entre para liberar. Seus créditos ficam vinculados à sua conta.",
    dashLeft: "imagens grátis restantes",
  },
  errors: {
    generic: "Algo deu errado. Tente novamente.",
    "File not found": "Arquivo não encontrado",
    "AI service temporarily unavailable. Please try again later.": "Serviço de IA indisponível no momento. Tente mais tarde.",
    "We couldn't process this file. Your credit was refunded.": "Não foi possível processar este arquivo. Seu crédito foi devolvido.",
    "Invalid tool": "Ferramenta inválida", "Empty file": "Arquivo vazio", "File larger than 40 MB": "Arquivo maior que 40 MB",
    "Please upload a valid PDF file": "Envie um arquivo PDF válido", "Invalid or protected PDF": "PDF inválido ou protegido",
    "Maximum 60 pages per PDF": "Máximo de 60 páginas por PDF",
    "Please upload a valid image (PNG, JPG, WEBP, BMP, TIFF)": "Envie uma imagem válida (PNG, JPG, WEBP, BMP, TIFF)",
    "You don't have enough credits": "Você não tem créditos suficientes",
    "This file is too large to export in this format right now. Try JPG or a lower DPI.": "Este arquivo é grande demais para exportar neste formato agora. Tente JPG ou um DPI menor. Nenhum crédito foi descontado.",
    "Failed to save the file. Please try again.": "Falha ao salvar o arquivo. Tente novamente.",
    "Processing interrupted. Credit refunded.": "Processamento interrompido. Crédito devolvido.",
    "This email is already registered": "Este e-mail já está cadastrado",
    "Too many attempts. Try again in 15 minutes.": "Muitas tentativas. Tente novamente em 15 minutos.",
    "Incorrect email or password": "E-mail ou senha incorretos",
    "Invalid options": "Opções inválidas",
    "Sign in with Google to use your credits": "Entre com o Google para usar seus créditos",
    "Email sign-up is disabled. Please sign in with Google.": "Cadastro por e-mail desativado. Entre com o Google.",
    "Batch upload is available on the Print Shop plan": "Envio em lote é exclusivo do Plano Gráfica",
    "Daily preview limit reached. Unlock or download your previews, or try again tomorrow.": "Limite diário de prévias atingido. Baixe suas prévias ou tente amanhã.",
    "You already have an active Print Shop plan": "Você já tem o Plano Gráfica ativo",
    "We couldn't process this file. No credit was used.": "Não foi possível processar este arquivo. Nenhum crédito foi usado.",
    "No active plan": "Nenhum plano ativo",
    "Your plan has no pending payment": "Seu plano não tem pagamento pendente",
  },
};
